import { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import NavbarData from './data' 
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorStatus, logApiError } from 'services/apiError'
import ReactTooltip from 'react-tooltip'
import * as FA from 'react-icons/fa'
import { IconContext } from 'react-icons'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'

import {
  Container,
  ProfilePicture,
  NavItem,
  NavButton,
  Label
} from '../styles'

export default function AdminNavbar () {
  const [loading, setLoading] = useState (false)
  const signed = AuthService.isSigned ()
  const admin = AuthService.getUser ()
  const token = AuthService.getToken ()
  const navigate = useNavigate ()

  const handleSignOut = async () => {
    try {
      setLoading (true)
      await cutileiApi.delete ('/auth/admins', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      setLoading (false)
      AuthService.adminSignOut ()
      navigate ('/admin', { replace: true })
    } catch (error) {
      setLoading (false)
      logApiError (error)
      if (getApiErrorStatus (error) === 401) {
        AuthService.adminSignOut ()
        navigate ('/', { replace: true })
      }
    }
  }

  return (
    <IconContext.Provider value={{color: '#252525'}}>
      <Container>
        {signed ? (
          <>
            <ProfilePicture src={admin.profile_picture} alt={admin.name}/>
            {NavbarData.map ((item, index) => (
              <NavItem key={index}>
                <NavLink
                  to={item.path}
                  end={item.path === '/admin'}
                  className={({ isActive }) => isActive ? 'active' : ''}
                  data-for={item.id}
                  data-tip
                >
                  {item.icon}
                </NavLink>
                <ReactTooltip
                  id={item.id}
                  effect='solid'
                  place='right'
                  backgroundColor='#252525'
                  tooltipRadius='10'
                >
                  <Label>{item.label}</Label>
                </ReactTooltip>
              </NavItem>
            ))}
            <NavItem>
              <NavButton onClick={handleSignOut} data-for='logout' data-tip>
                {loading ? (
                  <ButtonLoading style={{margin: 0}}/>
                ) : (
                  <FA.FaSignOutAlt/>
                )}
              </NavButton>
              <ReactTooltip
                id='logout'
                effect='solid'
                place='right'
                backgroundColor='#252525'
                tooltipRadius='10'
              >
                <Label>Sair</Label>
              </ReactTooltip>
            </NavItem>
          </>
          ) : (
            <NavItem>
              <NavLink to='/login' className={({ isActive }) => isActive ? 'active' : ''}>
                <FA.FaSignInAlt/>
              </NavLink>
            </NavItem>
          )
        }
      </Container>
    </IconContext.Provider>
  )
}
